import { render, staticRenderFns } from "./MedicamentoNaoPadronizado.vue?vue&type=template&id=7d24499c&"
import script from "./MedicamentoNaoPadronizado.vue?vue&type=script&lang=js&"
export * from "./MedicamentoNaoPadronizado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports